var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AggregationCountsApi } from '@ClientApi/aggregationCountsApi';
export const ADD_AGGREGATION_COUNTS = 'ADD_AGGREGATION_COUNTS';
export const SET_AGGREGATION_COUNTS_LOADING = 'SET_AGGREGATION_COUNTS_LOADING';
export class AddAggregationCounts {
    constructor(payload) {
        this.payload = payload;
        this.type = ADD_AGGREGATION_COUNTS;
    }
}
export class SetAggregationCountsLoading {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_AGGREGATION_COUNTS_LOADING;
    }
}
export const getAggregationCounts = (dispatch) => (match, params) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetAggregationCountsLoading({
        match,
        loading: true
    }));
    const aggregationCounts = yield AggregationCountsApi.loadAggregationCounts(match, params);
    dispatch(new AddAggregationCounts({
        match,
        aggregationCounts: aggregationCounts.redux[match]
    }));
    dispatch(new SetAggregationCountsLoading({
        match,
        loading: false
    }));
});
